import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {LineOfBusiness} from '../../model/proposal/line-of-business';

@Injectable({
  providedIn: 'root'
})
export class LineOfBusinessService {

  constructor(private readonly http: HttpClient) {
  }

  getLineOfBusiness(number: string) {
    return this.http.get<LineOfBusiness>(environment.backend + '/v1/lobs/' + number);
  }
}
